import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface InfoRowProps {
  icon: LucideIcon;
  label: string;
  value: string;
  iconColor?: string;
  valueColor?: string;
  action?: React.ReactNode;
  className?: string;
}

export function InfoRow({
  icon: Icon,
  label,
  value,
  iconColor = "text-indigo-500",
  valueColor = "text-[#003366]",
  action,
  className,
}: InfoRowProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-between p-4 bg-gray-50/50 rounded-2xl border border-gray-100 hover:border-indigo-200 transition-all",
        className,
      )}
    >
      <div className="flex items-center gap-4 overflow-hidden">
        <div
          className={cn(
            "w-10 h-10 rounded-lg bg-white flex items-center justify-center shadow-sm border border-gray-100 shrink-0",
            iconColor,
          )}
        >
          <Icon size={16} />
        </div>
        <div className="overflow-hidden">
          <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-0.5">
            {label}
          </p>
          <p className={cn("text-sm font-black truncate", valueColor)}>{value}</p>
        </div>
      </div>
      {action && <div className="shrink-0 ml-3">{action}</div>}
    </div>
  );
}
